import './HomePage.scss';
import '../PageHeader.scss';

import { DefaultRoutes } from 'Routes';
import InvitationModal from 'components/InvitationModal/InvitationModal';
import { useTranslation } from 'react-i18next';
import { HomePageCard } from './HomePageCard/HomePageCard';

import parametersImg from 'images/HomePage/ParametersImg.jpg';
import learningHubImg from 'images/HomePage/LearningHubImg.jpg';
import eventsImg from 'images/HomePage/EventsImg.jpg';

import { ReactComponent as ParametersIcon } from 'images/icons/Adjustment.svg';
import { ReactComponent as LearningHubIcon } from 'images/icons/Book.svg';
import { ReactComponent as EventsIcon } from 'images/icons/Calendar.svg';
import { useGetProfile } from 'queryHooks/Profile/useGetProfile';
import useSetPageTitle from 'utilities/useSetPageTitle';

export const HomePage = () => {
  const { t } = useTranslation();
  const profile = useGetProfile().data;
  useSetPageTitle({
    title: t('WelcomeUserMessage', {
      ns: 'homePage',
      name: profile?.firstName,
    }),
  });

  return (
    <>
      {profile && (
        <>
          <div className='default-page-header'>
            <h1 className='page-title'>
              {t('WelcomeUserMessage', {
                ns: 'homePage',
                name: profile?.firstName,
              })}
            </h1>
            <span className='page-subtitle'>{t('WelcomeToTrackmanUniversity', { ns: 'homePage' })}</span>
          </div>
          <div className='homepage-container'>
            <div className='shortcut-tiles'>
              <>
                <HomePageCard
                  title={t('Parameters', { ns: 'trackmanParameters' })}
                  description={t('TrackmanParametersDescription', { ns: 'homePage' })}
                  imageSrc={parametersImg}
                  route={DefaultRoutes.TrackmanParameters}
                  icon={<ParametersIcon />}
                />

                <HomePageCard
                  title={t('LearningHub', { ns: 'learningHub' })}
                  description={t('LearningHubDescription', { ns: 'homePage' })}
                  imageSrc={learningHubImg}
                  route={DefaultRoutes.LearningHub}
                  icon={<LearningHubIcon />}
                />

                <HomePageCard
                  title={t('Events', { ns: 'trackmanEvents' })}
                  description={t('EventsDescription', { ns: 'homePage' })}
                  imageSrc={eventsImg}
                  route={DefaultRoutes.TrackmanEvents}
                  icon={<EventsIcon />}
                />
              </>
            </div>
            <InvitationModal />
          </div>
        </>
      )}
    </>
  );
};

export default HomePage;
